<div style="margin-top:1%">
  <h4 class="text-center">OPT-OUT FORM</h4>
  <div class="text-center" style="font-style:italic">Ohio National Settlement</div>
</div>

<div class="row mt-4">
  <div class="col-md-12">
    Only use this Form if you want to request exclusion from (i.e., opt-out of) the proposed settlement class. 
  </div>
</div>
<div class="row mt-4">
  <div class="col-md-12">
    To be effective as an opt-out from the proposed settlement, this form must be completed, signed, and sent, as outlined above, <b>no later than June 29, 2026.</b>  If this form is not
    postmarked or received by this date, you will remain in the Settlement.<br /><br />

    <b><u>Opting out of the Settlement is not the same as objecting to the Settlement Agreement.</u></b> If you request exclusion from the Settlement prior to <br /><b>June 29, 2026,</b> you will not
    be bound by the terms of the Settlement Agreement and therefore cannot argue that the Settlement Agreement should not be approved. More information about objecting to the Settlement
    is available on the FAQ page of this website.

  </div>
</div>
<div class="row mt-4">
  <div class="col-md-12">
    <form [formGroup]="optOutForm" (ngSubmit)="onSubmit()" autocomplete="off" novalidate #formRef="ngForm">
      <div class="row lightgraybackground">
        <div class="col-md-12 text-center">
        Settlement Class Member Information
        </div>
      </div>
      <div class="row rowformat mt-4">
        <div class="col-md-12">
          <div class="form-group">
            <label for="brokerDealerName"><b>Broker-Dealer Name :</b><span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="brokerDealerName" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.brokerDealerName.errors }" />
            <div *ngIf="submitted && f.brokerDealerName.errors" class="invalid-feedback">
              <div *ngIf="f.brokerDealerName.errors.required">This field is required</div>
              <div *ngIf="f.brokerDealerName.errors.maxlength">This field must not be at greater 50 characters</div>
              <div *ngIf="f.brokerDealerName.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.brokerDealerName.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row rowformat">
        <div class="col-md-12">
          <div class="form-group">
            <label for="noticeId"><b>Notice ID:</b><span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="noticeId" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.noticeId.errors }" />
            <div *ngIf="submitted && f.noticeId.errors" class="invalid-feedback">
              <div *ngIf="f.noticeId.errors.required">This field is required</div>
              <div *ngIf="f.noticeId.errors.minlength">This field must be at least 10 digits</div>
              <div *ngIf="f.noticeId.errors.maxlength">
                This field must not be at greater 10 digits
              </div>
              <div *ngIf="f.noticeId.errors.pattern">This field accepts only numerical digits 0-9</div>
            </div>
          </div>
          * Your Notice ID was on the notice of the Settlement you received by postal mail.  If you do not have your Notice ID, call or email the Settlement Administrator
          for assistance at 1-877-719-6771 or <a href="mailto:info@ONTrailssSettlement.com">info@ONTrailssSettlement.com.</a><br /><br />
        </div>
      </div>
      <div class="row rowformat">
        <div class="col-md-12">
        <b><u>Current Contact Information</u></b>
        </div>
      </div>
      <div class="row rowformat">
        <div class="col-md-12">
          <div class="form-group">
            <label for="street1"><b>Address 1:</b> <span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="street1" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street1.errors }" />
            <div *ngIf="submitted && f.street1.errors" class="invalid-feedback">
              <div *ngIf="f.street1.errors.required">This field is required</div>
              <div *ngIf="f.street1.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.street1.errors.maxlength">This field must not be at greater 50 characters</div>
              <div *ngIf="f.street1.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row rowformat">
        <div class="col-md-4">
          <div class="form-group">
            <label for="city"><b>City:</b><span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="city" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.city.errors }" />
            <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
              <div *ngIf="f.city.errors.required">This field is required</div>
              <div *ngIf="f.city.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.city.errors.maxlength">This field must not be at greater 40 characters</div>
              <div *ngIf="f.city.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="state"><b>State:</b><span style="color:red" class="required"> *</span></label>
            <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
              <option value="">Please Select A State</option>
              <option *ngFor="let allstate of allStates">
                {{allstate.Name}}
              </option>
            </select>
            <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
              <div *ngIf="f.state.errors.required">This field is required</div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="zip"><b>Zip Code:</b><span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="zip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.zip.errors }" />
            <div *ngIf="submitted && f.zip.errors" class="invalid-feedback">
              <div *ngIf="f.zip.errors.required">This field is required</div>
              <div *ngIf="f.zip.errors.pattern">
                US zip Code with format 99999 or 99999-9999 alone are accepted
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row rowformat">
        <div class="col-md-6">
          <div class="form-group">
            <label for="emailAddress"><b>Email Address:</b></label>
            <input type="text" class="form-control" formControlName="emailAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.emailAddress.errors }" />
            <div *ngIf="submitted && f.emailAddress.errors" class="invalid-feedback">
              <div *ngIf="f.emailAddress.errors.maxlength">This field must not be at greater 255 characters</div>
              <div *ngIf="f.emailAddress.errors.pattern">This is not a valid email address</div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="phone1"><b>Preferred Phone Number:</b></label>
            <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" class="form-control" formControlName="phone1" placeholder="" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.phone1.errors }" />
            <div *ngIf="submitted && f.phone1.errors" class="invalid-feedback">
              <!--<div *ngIf="f.phone1.errors.required">This field is required</div>-->
              <div *ngIf="f.phone1.errors.minlength">This field must be at least 10 digits</div>
              <div *ngIf="f.phone1.errors.maxlength">This field must not be at greater 10 digits</div>
              <div *ngIf="f.phone1.errors.pattern">Only use numbers</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row rowformat">
        <div class="col-md-12" style="font-style:italic">
          Your contact information will be used by the Settlement Administrator to contact you, if necessary, about your request for exclusion. Provision of your phone number is optional.
        </div>
      </div>
      <br />
      <div class="row lightgraybackground">
        <div class="col-md-12 text-center">
          Attestation, Opt-Out Request, Signature, and Submit
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12">
          Through the submission of this form, I attest under the penalty of perjury that the broker-dealer listed above has received notice of the class action Settlement in
          this case and is a member of the class of persons described in the notice.  I further attest that I am authorized to request exclusion from the Settlement in <i>
            Veritas
            Independent Partners, LLC v. The Ohio National Life Insurance Company, et al.,
          </i> Case No. 1:18-cv-769 on behalf of that broker-dealer and that I request exclusion.
          By signing below, I agree to the submission of this Opt-Out Form.<br /><br />

          IF SUBMITTED ELECTRONICALLY: <br />
          <div class="form-group form-check">
            <input type="checkbox" formControlName="optOutAcknowledgement" class="form-check-input" />
            <label for="optOutAcknowledgement">
              <b>Checking this box constitutes my electronic signature and election to opt out of the Settlement on behalf of myself.</b>
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="signature"><b>Electronic Signature:</b> <span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': submitted && f.signature.errors }" />
            <div *ngIf="submitted && f.signature.errors" class="invalid-feedback">
              <div *ngIf="f.signature.errors.required">This field is required</div>
              <div *ngIf="f.signature.errors.maxlength">This field must not be at greater 50 characters</div>
              <div *ngIf="f.signature.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.signature.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens,
                brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="form-group">
            <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" ngDefaultControl [ngClass]="{ 'is-invalid': submitted && f.googleRecaptchaToken.errors }"></re-captcha>
            <div *ngIf="submitted && f.googleRecaptchaToken.errors">
              <div *ngIf="f.googleRecaptchaToken.errors.required" class="custom-error">This field is required</div>
            </div>
          </div>
        </div>
      </div>
      <ul class="list-inline text-center">
        <li><button type="submit" class="btn btn-primary" [disabled]="clicked">SUBMIT</button></li>
      </ul>
    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
  </div>
</div>
